import { render, staticRenderFns } from "./PlatformResources.vue?vue&type=template&id=21cffa02&scoped=true"
import script from "./PlatformResources.vue?vue&type=script&lang=js"
export * from "./PlatformResources.vue?vue&type=script&lang=js"
import style0 from "./PlatformResources.vue?vue&type=style&index=0&id=21cffa02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cffa02",
  null
  
)

export default component.exports